import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "name", "path"];
import "core-js/modules/es.function.name.js";
import React from 'react';
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import Box from 'components/Box';
import Icon from 'components/Icon';
import InlineList from 'components/InlineList';
import Tab from 'components/Tab';
function TabWithIcon(_ref) {
  var children = _ref.children,
    name = _ref.name,
    path = _ref.path,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Tab, _extends({
    as: NavLink,
    height: 56,
    activeClassName: "is-active",
    to: {
      pathname: path,
      state: {
        shouldResetScroll: false
      }
    }
  }, otherProps), /*#__PURE__*/React.createElement(Icon, {
    name: name,
    mr: "xs"
  }), children);
}
function PlaylistTabs(_ref2) {
  var renderContent = _ref2.renderContent,
    renderComments = _ref2.renderComments;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var match = useRouteMatch();

  // If comments are disabled, we just render the playlist's content
  // directly – no need for tabs.
  if (!config.enableComments) {
    return renderContent();
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    breakpoints: "s",
    textAlign: ['center', 'left'],
    borderBottom: "thin",
    pl: "xxs",
    mb: "m"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "l",
    as: "nav",
    itemAs: "div",
    "aria-label": t('content_type_playlist')
  }, /*#__PURE__*/React.createElement(TabWithIcon, {
    exact: true,
    path: match.url,
    name: "playlist"
  }, t('content_type_content_plural')), /*#__PURE__*/React.createElement(TabWithIcon, {
    path: "".concat(match.url, "/comments"),
    name: "chat"
  }, t('comments_title')))), /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    path: "".concat(match.path, "/comments"),
    render: renderComments
  }), /*#__PURE__*/React.createElement(Route, {
    path: match.path,
    render: renderContent
  })));
}
export default PlaylistTabs;